import { _ as n } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { fordProIcons as F } from "@ucl/shared-icons";
import { c as O } from "./index-8b07dec9.js";
import S from "react";
import { styled as o, css as i } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as H } from "./getMetrics-953aa4f8.js";
import { Grid as x } from "./grid.js";
import { hTag as P } from "./hTag.js";
import { Tooltip as q } from "./tooltip.js";
import { jsxs as c, jsx as m } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "@ucl/shared-component-foundations";
import "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "react-dom";
import "./es.object.keys-9d66766f.js";
import "./usePopoverIndex.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./useWindowSize.js";
import "./index-5d0f31c6.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./string-trim-14e37ad3.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./es.string.starts-with-a6645e0a.js";
var y, h, f, b, T, j, R, I, g, W, _, z = F.InformationFilled, E = o.div(y || (y = n([`
  &.section-mainWrapper {
    `, `;
  }
`])), function(e) {
  var t = e.theme, a = t.componentStyles, r = t.components.readOnlySection;
  return i(r.MainWrapper, a);
}), V = o.div(h || (h = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.HeaderSection);
}), k = o(P)(f || (f = n([`
  && {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.SectionTitle);
}), A = o.div(b || (b = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.Subtitle);
}), B = o.div(T || (T = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.Description);
}), J = o.div(j || (j = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.SecondaryLabel);
}), K = o.div(R || (R = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.ContentWrapper);
}), Q = o.div(I || (I = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.RowItemWrapper);
}), U = o.div(g || (g = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.RowItemTitle);
}), X = o.div(W || (W = n([`
  `, `;
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.RowTitleWrapper);
}), Y = o(x)(_ || (_ = n([`
  &.grid--Content {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.readOnlySection;
  return i(t.GridContent);
}), w = function(t) {
  var a = t.label, r = t.infoText, d = t.value;
  return /* @__PURE__ */ c(Q, {
    "data-testid": "Items",
    children: [/* @__PURE__ */ c(X, {
      children: [/* @__PURE__ */ m(U, {
        children: a
      }), r && /* @__PURE__ */ m(q, {
        placement: "auto",
        title: r,
        children: /* @__PURE__ */ m(z, {
          tabIndex: 0,
          size: "s"
        })
      })]
    }), /* @__PURE__ */ m(K, {
      children: d
    })]
  });
}, Z = function(t) {
  var a = t.className, r = t.header, d = t.children, s = t.columnOptions, p = s === void 0 ? {
    xl: 2,
    l: 4,
    m: 6,
    s: 12
  } : s, v = t.variant, u = v === void 0 ? "Condensed" : v, C = H({
    label: "ReadOnlySection"
  }), L = p.xl, N = p.l, D = p.m, M = p.s, G = function() {
    return /* @__PURE__ */ m(Y, {
      className: O([["grid--Content--" + u]]),
      gutterWidth: 24,
      children: S.Children.map(d, function(l, $) {
        return l && /* @__PURE__ */ S.isValidElement(l) && l.type === w ? /* @__PURE__ */ m(x.Item, {
          xl: L,
          l: N,
          m: D,
          s: M,
          children: l
        }, $) : null;
      })
    });
  };
  return /* @__PURE__ */ c(E, Object.assign({
    className: O([["" + a, "section-mainWrapper", "section-mainWrapper--" + u]])
  }, C, {
    children: [/* @__PURE__ */ c(V, {
      "data-testid": "headersection",
      children: [(r == null ? void 0 : r.title) && /* @__PURE__ */ m(k, {
        as: r == null ? void 0 : r.headingLevel,
        children: r == null ? void 0 : r.title
      }), (r == null ? void 0 : r.subTitle) && /* @__PURE__ */ m(A, {
        children: r == null ? void 0 : r.subTitle
      }), (r == null ? void 0 : r.description) && /* @__PURE__ */ m(B, {
        children: r == null ? void 0 : r.description
      }), (r == null ? void 0 : r.secondaryLabel) && /* @__PURE__ */ m(J, {
        children: r == null ? void 0 : r.secondaryLabel
      })]
    }), G()]
  }));
};
Z.Item = w;
export {
  Z as ReadOnlySection
};
